<script setup lang="ts">
const props = defineProps<{
  question: string
  answers: Record<string, string>
  brandColor: string
}>()
const isOpen = ref(false)
const formattedAnswers = computed(() => {
  return Object.entries(props.answers)
    .sort((a, b) => (a[0] === 'Answer' ? -1 : b[0] === 'Answer' ? 1 : 0))
    .map(([key, value]) => ({
      title: key,
      content: value
    }))
})
const answerStyle = computed(() => ({}))
const questionStyle = computed(() => ({
  backgroundColor: props.brandColor,
  color: isLightColor(props.brandColor) ? '#000' : '#fff'
}))
</script>

<template>
  <div
    class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
  >
    <button
      class="w-full p-4 flex justify-between items-center hover:bg-opacity-90 transition-colors"
      :style="questionStyle"
      @click="isOpen = !isOpen"
    >
      <h3 class="text-xl font-semibold text-left">
        {{ question }}
      </h3>
      <svg
        class="w-5 h-5 transition-transform duration-200"
        :class="{ 'rotate-180': isOpen }"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
    <div
      v-show="isOpen"
      class="divide-y divide-gray-100 transition-all duration-200"
      :style="answerStyle"
    >
      <div class="p-6 space-y-3">
        <template
          v-for="(item, index) in formattedAnswers"
          :key="index"
        >
          <template v-if="item.title === 'Answer'">
            <p
              class="text-gray-800"
              v-html="item.content"
            />
          </template>
          <div
            v-else
            class="flex gap-2"
          >
            <span class="font-medium text-gray-800">{{ item.title }}:</span>
            <span
              class="text-gray-800"
              v-html="item.content"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
